import { FontTheme } from '@kite-js/theme-types';
import colors from '@theme/rurubu/theme-rurubu/colors';
import basicLineHeights from './basicLineHeights';
import faces from './faces';
import familiesByLanguage from './familiesByLanguage';
import sizes from './sizes';
import tallerLineHeights from './tallerLineHeights';
import weights from './weights';

const font: FontTheme = {
    basicLineHeights,
    sizes,
    weights,
    faces,
    familiesByLanguage,
    tallerLineHeights,
    family: '',
    defaultColor: colors.textScale[800],
};

export default font;
